import ChangeItemBuilder from '../ChangeItemBuilder.js';
import RemoveFilterActionHandler from './RemoveFilterActionHandler.js';
class ChoiceRemoveFilterActionHandler extends RemoveFilterActionHandler {
    process(query, payload) {
        const { facetId } = payload;
        query.getRequest().removeSearchFacetTypeFilter(facetId, ChangeItemBuilder.buildItem(query, payload));
    }
}
export default ChoiceRemoveFilterActionHandler;
